import type { ReactNode } from 'react'

/** İK sayfalarının başlığı: başlık, açıklama ve sağda sayfa düğmeleri. */
export function HrPageHeader({
  title,
  description,
  actions,
}: {
  title: string
  description: string
  actions?: ReactNode
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="flex max-w-3xl flex-col gap-1">
        <h1 className="text-lg font-semibold">{title}</h1>
        <p className="text-text-secondary text-sm">{description}</p>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
